import type { CentralPeriodKey } from '../services/MendsVisionService';

/** Filtros da Central que a pergunta à MENDS herda (mesmas conexões e período da tela). */
export type CentralQuestionContext = {
  sectorIds: number[];
  period: CentralPeriodKey;
  /** Ex.: "Últimos 7 dias · Denkor" — só exibição. */
  label: string;
};

const EVENT = 'mends-ask-central';

/** Abre a Barra da IA já no contexto da Central (o botão "Perguntar à MENDS"). */
export function openCentralQuestion(detail: CentralQuestionContext): void {
  window.dispatchEvent(new CustomEvent<CentralQuestionContext>(EVENT, { detail }));
}

export function subscribeCentralQuestion(listener: (detail: CentralQuestionContext) => void): () => void {
  const handler = (e: Event) => {
    const detail = (e as CustomEvent<CentralQuestionContext>).detail;
    if (detail && Array.isArray(detail.sectorIds) && detail.sectorIds.length > 0) listener(detail);
  };
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
}

/** Perguntas sugeridas quando a Barra abre a partir da Central (respondidas com os números da tela). */
export const CENTRAL_SUGGESTED_QUESTIONS = [
  'Por que a conversão caiu?',
  'Qual funcionário digital mais transferiu?',
  'De onde vêm os leads?',
  'Quais as maiores oportunidades?',
  'Sobre o que os clientes mais falam?',
];

export function centralStatusLabel(status: string): string | null {
  switch (status) {
    case 'insufficient_data': return 'Faltam dados para afirmar';
    case 'out_of_scope': return 'Fora do que a Central mede';
    case 'unavailable': return 'Sem resposta verificada';
    default: return null;
  }
}
